import {
  DELETE_DISCOUNT_RULE,
  GET_DISCOUNT_RULES,
  SAVE_DISCOUNT_RULE,
  SET_DISCOUNT_RULES_LOADING,
  SHOW_CREATE_DISCOUNT_RULE_MODAL,
  SHOW_EDIT_DISCOUNT_RULE_MODAL,
  UPDATE_DISCOUNT_RULES,
  SHOW_EDITOR_MODAL_LOADING,
  SET_EDITOR_ERROR_MESSAGE,
  SHOW_DELETE_CONFIRMATION_MODAL,
  DISCOUNT_RULE_LOG_SET_SHOWN,
  DISCOUNT_RULE_DO_SHOW_LOG,
  DISCOUNT_RULE_LOG_CHANGE_PAGE,
  DISCOUNT_RULE_LOG_SET_DATA,
  DISCOUNT_RULE_LOG_SET_IS_LOADING,
  DISCOUNT_RULE_LOG_SET_ERRORS,
} from './actionTypes';

export const getDiscountRules = () => ({
  type: GET_DISCOUNT_RULES,
});

export const saveDiscountRule = data => ({
  type: SAVE_DISCOUNT_RULE,
  payload: data,
});

export const updateDiscountRules = discountRules => ({
  type: UPDATE_DISCOUNT_RULES,
  payload: discountRules,
});

export const deleteDiscountRule = id => ({
  type: DELETE_DISCOUNT_RULE,
  payload: { id },
});

export const setDiscountRulesLoading = isLoading => ({
  type: SET_DISCOUNT_RULES_LOADING,
  payload: isLoading,
});

export const showCreateDiscountRuleModal = shown => ({
  type: SHOW_CREATE_DISCOUNT_RULE_MODAL,
  payload: shown,
});

export const showEditDiscountRuleModal = (shown, discountRule) => ({
  type: SHOW_EDIT_DISCOUNT_RULE_MODAL,
  payload: { shown, discountRule },
});

export const showEditorModalLoading = isLoading => ({
  type: SHOW_EDITOR_MODAL_LOADING,
  payload: isLoading,
});

export const setEditorErrorMessage = (errorMessage, errors = []) => ({
  type: SET_EDITOR_ERROR_MESSAGE,
  payload: errorMessage != null ? { message: errorMessage, errors } : null,
});

export const showDeleteConfirmationModal = (shown, discountRule) => ({
  type: SHOW_DELETE_CONFIRMATION_MODAL,
  payload: { shown, discountRule },
});

export const setLogModalShown = shown => ({
  type: DISCOUNT_RULE_LOG_SET_SHOWN,
  payload: { shown },
});

export const doShowLogs = () => ({
  type: DISCOUNT_RULE_DO_SHOW_LOG,
});

export const setLogPage = page => ({
  type: DISCOUNT_RULE_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: DISCOUNT_RULE_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: DISCOUNT_RULE_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: DISCOUNT_RULE_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);
